import { createElementVNode as _createElementVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "office-shell" }
const _hoisted_2 = { class: "office-nav" }
const _hoisted_3 = { class: "office-tabs" }
const _hoisted_4 = { class: "office-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OfficeFornecedoresTab = _resolveComponent("OfficeFornecedoresTab")!
  const _component_OfficeNotasFiscaisTab = _resolveComponent("OfficeNotasFiscaisTab")!
  const _component_OfficeRequisicaoCompraTab = _resolveComponent("OfficeRequisicaoCompraTab")!
  const _component_OfficeOrdemCompraTab = _resolveComponent("OfficeOrdemCompraTab")!
  const _component_OfficeCentroCustoTab = _resolveComponent("OfficeCentroCustoTab")!
  const _component_OfficeQuestionariosTab = _resolveComponent("OfficeQuestionariosTab")!
  const _component_GerenciaEscritorio = _resolveComponent("GerenciaEscritorio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["office-tab", { active: _ctx.tab === 'fornecedores' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = 'fornecedores')),
          type: "button"
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("rect", {
              x: "2",
              y: "7",
              width: "20",
              height: "14",
              rx: "2"
            }),
            _createElementVNode("path", { d: "M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" })
          ], -1),
          _createTextVNode(" Fornecedores ", -1)
        ]))], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["office-tab", { active: _ctx.tab === 'nf' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 'nf')),
          type: "button"
        }, [...(_cache[8] || (_cache[8] = [
          _createStaticVNode("<svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-11a1e46c><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-11a1e46c></path><polyline points=\"14 2 14 8 20 8\" data-v-11a1e46c></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-11a1e46c></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-11a1e46c></line><polyline points=\"10 9 9 9 8 9\" data-v-11a1e46c></polyline></svg> Notas Fiscais ", 2)
        ]))], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["office-tab", { active: _ctx.tab === 'rc' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = 'rc')),
          type: "button"
        }, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("path", { d: "M9 11l3 3L22 4" }),
            _createElementVNode("path", { d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" })
          ], -1),
          _createTextVNode(" Req. de Compra ", -1)
        ]))], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["office-tab", { active: _ctx.tab === 'oc' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tab = 'oc')),
          type: "button"
        }, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("path", { d: "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" }),
            _createElementVNode("line", {
              x1: "3",
              y1: "6",
              x2: "21",
              y2: "6"
            }),
            _createElementVNode("path", { d: "M16 10a4 4 0 0 1-8 0" })
          ], -1),
          _createTextVNode(" Ordens de Compra ", -1)
        ]))], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["office-tab", { active: _ctx.tab === 'cc' }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tab = 'cc')),
          type: "button"
        }, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("line", {
              x1: "12",
              y1: "1",
              x2: "12",
              y2: "23"
            }),
            _createElementVNode("path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" })
          ], -1),
          _createTextVNode(" Centro de Custo ", -1)
        ]))], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["office-tab", { active: _ctx.tab === 'questionarios' }]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tab = 'questionarios')),
          type: "button"
        }, [...(_cache[12] || (_cache[12] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("path", { d: "M9 11l3 3L22 4" }),
            _createElementVNode("path", { d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" })
          ], -1),
          _createTextVNode(" Questionários ", -1)
        ]))], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["office-tab", { active: _ctx.tab === 'gerencia' }]),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.tab = 'gerencia')),
          type: "button"
        }, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "3"
            }),
            _createElementVNode("path", { d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" })
          ], -1),
          _createTextVNode(" Gerenciar Escritório ", -1)
        ]))], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.tab === 'fornecedores')
        ? (_openBlock(), _createBlock(_component_OfficeFornecedoresTab, { key: 0 }))
        : (_ctx.tab === 'nf')
          ? (_openBlock(), _createBlock(_component_OfficeNotasFiscaisTab, { key: 1 }))
          : (_ctx.tab === 'rc')
            ? (_openBlock(), _createBlock(_component_OfficeRequisicaoCompraTab, { key: 2 }))
            : (_ctx.tab === 'oc')
              ? (_openBlock(), _createBlock(_component_OfficeOrdemCompraTab, { key: 3 }))
              : (_ctx.tab === 'cc')
                ? (_openBlock(), _createBlock(_component_OfficeCentroCustoTab, { key: 4 }))
                : (_ctx.tab === 'questionarios')
                  ? (_openBlock(), _createBlock(_component_OfficeQuestionariosTab, { key: 5 }))
                  : (_ctx.tab === 'gerencia')
                    ? (_openBlock(), _createBlock(_component_GerenciaEscritorio, { key: 6 }))
                    : _createCommentVNode("", true)
    ])
  ]))
}